import { ref } from 'vue';

/** Active CDP project — set by useCdpProjectContext / CdpPageShell. */
export const activeProjectId = ref<string | null>(null);

export function setActiveProjectId(id: string | null): void {
  activeProjectId.value = id;
}
